const wildcardPatternToRegexBody = (pattern: string) => {
  const tempPattern = pattern.replace(/\*\*/g, '§§')

  const escapedPattern = tempPattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&')

  const singleStarPattern = escapedPattern.replace(/\*/g, '[^/]*')

  return singleStarPattern.replace(/§§/g, '.*')
}

const LOCALE_HOME_SUB_PATTERNS = ['/*', '/*/', '/*/?*'] as const

/**
 * Converts a wildcard pattern into a regular expression.
 *
 * Supported wildcards:
 * - `*` matches one path segment (any run of characters except `/`).
 * - `**` matches zero or more characters, including `/`.
 *
 * When the whole pattern is exactly `/`, it matches the same strings as the union of three
 * fixed sub-patterns used for locale home (one path segment, optional trailing slash, optional
 * query only when a slash precedes the question mark).
 *
 * @param pattern - The wildcard pattern to convert.
 * @returns The generated regular expression.
 */
export const convertPatternToRegex = (pattern: string) => {
  if (pattern === '/') {
    const localeHomeAlternatives = LOCALE_HOME_SUB_PATTERNS.map(wildcardPatternToRegexBody)
    return new RegExp(`^(?:${localeHomeAlternatives.join('|')})$`)
  }

  return new RegExp(`^${wildcardPatternToRegexBody(pattern)}$`)
}
